var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg48(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2460_2627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#2775CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3125 42.3829C20.3125 42.9688 19.8438 43.3008 19.2969 43.1251C11.7188 40.7032 6.25 33.6329 6.25 25.254C6.25 16.8946 11.7188 9.80474 19.2969 7.38286C19.8633 7.20708 20.3125 7.53911 20.3125 8.12505V9.58989C20.3125 9.98052 20.0195 10.4297 19.6484 10.5665C13.6523 12.7735 9.375 18.5352 9.375 25.254C9.375 31.9922 13.6523 37.7344 19.6484 39.9219C20.0195 40.0586 20.3125 40.5079 20.3125 40.8985V42.3829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 36.9727C26.5625 37.4023 26.2109 37.7539 25.7812 37.7539H24.2187C23.7891 37.7539 23.4375 37.4023 23.4375 36.9727V34.5117C20.0195 34.043 18.3594 32.1484 17.9101 29.5312C17.832 29.082 18.1836 28.6914 18.6328 28.6914H20.4101C20.7812 28.6914 21.0937 28.9648 21.1719 29.3164C21.5039 30.8594 22.4023 32.0508 25.1367 32.0508C27.1484 32.0508 28.5937 30.918 28.5937 29.2383C28.5937 27.5586 27.7539 26.9141 24.7851 26.4258C20.4101 25.8398 18.3398 24.5117 18.3398 21.0937C18.3398 18.457 20.3516 16.3867 23.4375 15.957V13.5352C23.4375 13.1055 23.7891 12.7539 24.2187 12.7539H25.7812C26.2109 12.7539 26.5625 13.1055 26.5625 13.5352V16.0156C29.082 16.4648 30.6836 17.8906 31.2109 20.2734C31.3086 20.7227 30.957 21.1328 30.4883 21.1328H28.8476C28.4961 21.1328 28.2031 20.8984 28.1055 20.5664C27.6562 19.0625 26.582 18.3984 24.707 18.3984C22.6367 18.3984 21.5625 19.3945 21.5625 20.8008C21.5625 22.2852 22.168 23.0273 25.3516 23.4766C29.6484 24.0625 31.875 25.293 31.875 28.9453C31.875 31.7187 29.8047 33.9648 26.582 34.4727V36.9727H26.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7031 43.125C30.1367 43.3008 29.6875 42.9688 29.6875 42.3829V40.918C29.6875 40.4883 29.9414 40.0782 30.3516 39.9415C36.3281 37.754 40.625 31.9922 40.625 25.2735C40.625 18.5352 36.3477 12.793 30.3516 10.6055C29.9805 10.4688 29.6875 10.0196 29.6875 9.62895V8.16411C29.6875 7.57817 30.1562 7.24614 30.7031 7.42192C38.2812 9.80474 43.75 16.8946 43.75 25.254C43.75 33.6329 38.2812 40.7032 30.7031 43.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 37.9687L42.3437 42.4219V25.4883L34.6875 37.9687Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 25.4883V42.4219L50 37.9687L42.3438 25.4883Z",
    fill: "#878787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 34.5508L50 37.9688L42.3438 42.4219V34.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3437 34.5508V42.4219L34.6875 37.9688L42.3437 34.5508Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6875 39.3945L42.3437 50V43.8477L34.6875 39.3945Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3438 43.8477V50L50 39.3945L42.3438 43.8477Z",
    fill: "#878787"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2460_2627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48);
export default __webpack_public_path__ + "static/media/48.41b977c288bd47b26a70eefdf6f386f0.svg";
export { ForwardRef as ReactComponent };